import { AxiosPromise, AxiosStatic } from "axios";
import { Dividend } from "../types/Dividend";

export const findDividendById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (dividendId: string): AxiosPromise<Dividend> =>
    await appAxios.get(`${serverURL}/dividends/${dividendId}`, {
      withCredentials: true,
    });
